import { FC } from 'react';
import { SpaceKind } from 'shared';

import {
  GlobeIcon,
  LockIcon,
  SlashCircleIcon,
  SuccessCircleIcon,
  VaultFolderIcon,
  WorkspaceFolderIcon,
} from '../../../../assets/icons/index';
import { WorkspaceCardStatus } from '../../types/data-room.types';

export type SpaceTileProps = {
  description: string;
  kind: SpaceKind;
  name: string;
  onOpen: () => void;
  status?: WorkspaceCardStatus;
};

const SpaceTileIcon: FC<{ kind: SpaceKind }> = ({ kind }) => {
  if (kind === SpaceKind.VAULT) {
    return <VaultFolderIcon height={48} iconColor="#475467" width={48} />;
  }

  if (kind === SpaceKind.WORKSPACE) {
    return <WorkspaceFolderIcon height={48} width={48} />;
  }

  return <GlobeIcon height={48} width={48} />;
};

const SpaceTileStatusIcon: FC<{ status: WorkspaceCardStatus }> = ({ status }) => {
  if (status === WorkspaceCardStatus.LOCKED) {
    return <LockIcon className="size-4" height={16} iconColor="#DC6803" width={16} />;
  }

  if (status === WorkspaceCardStatus.ACTIVE) {
    return <SuccessCircleIcon height={16} iconColor="#039855" width={16} />;
  }

  return <SlashCircleIcon className="size-4" height={16} iconColor="#344054" width={16} />;
};

export const SpaceTile: FC<SpaceTileProps> = ({ description, kind, name, onOpen, status }) => (
  <button
    className="relative flex min-w-0 flex-col items-center gap-4 rounded-lg border border-gray-100 p-4 text-center transition-colors hover:bg-gray-25"
    onClick={onOpen}
    type="button"
  >
    <SpaceTileIcon kind={kind} />
    <span className="flex w-full min-w-0 flex-col items-center gap-2">
      <span className="w-full truncate text-sm font-[550] leading-5 text-gray-700">{name}</span>
      {description && (
        <span className="line-clamp-3 w-full text-label-sm font-medium text-gray-500">
          {description}
        </span>
      )}
    </span>
    {status && (
      <span className="absolute right-1.5 top-1.5 flex size-4 items-center justify-center">
        <SpaceTileStatusIcon status={status} />
      </span>
    )}
  </button>
);
